import React from "react";
import HeadLine from "../headLine";
import Feature_collections_carousel from "../carousel/Feature_collection_carousel";
import Image from "next/image";
import Collection_category from "./collection_category";

const Feature_collections = ({ bgWhite = false }) => {
  return (
    <div>
      <section className="py-24 relative">
        {bgWhite && (
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <Image
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full"
              width={800}
              height={800}
            />
          </picture>
        )}
        <div className="container">
          <HeadLine
            text="Featured Campaigns"
            classes="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-5xl text-center uppercase"
          />
          <div className="relative">
            <Feature_collections_carousel />
          </div>
        </div>
        <Collection_category bgWhite={true} />
      </section>
    </div>
  );
};

export default Feature_collections;
